import { render, staticRenderFns } from "./resource-online-booking-config-form.vue?vue&type=template&id=3f487f51&"
import script from "./resource-online-booking-config-form.vue?vue&type=script&lang=ts&"
export * from "./resource-online-booking-config-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports